// إعداد مركزي للقائمة الجانبية — Routes موجودة فعلياً فقط
// لكل عنصر: العنوان، الأيقونة، Route، الأدوار المسموحة (فارغ = الجميع)،
// الصلاحية المطلوبة (للاستخدام المستقبلي)، أنواع المنشآت، وحالة التفعيل
import { FINANCE_ROLES } from './organization';

export const organizationNavigation = [
  {
    group: 'الرئيسية',
    key: 'main',
    items: [
      { name: 'لوحة التحكم', href: '/dashboard', icon: 'home', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
    ],
  },
  {
    group: 'الإدارة الرياضية',
    key: 'sports',
    items: [
      { name: 'اللاعبون', href: '/players', icon: 'users', roles: [], permission: 'view_players', orgTypes: ['club', 'academy'], enabled: true },
      { name: 'الفرق والفئات', href: '/teams', icon: 'userGroup', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'المباريات', href: '/matches', icon: 'calendar', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'البطولات', href: '/tournaments', icon: 'trophy', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'الحضور والانصراف', href: '/attendance', icon: 'clock', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'برامج الأكاديمية', href: '/programs', icon: 'layers', roles: ['admin', 'manager'], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'بوابة ولي الأمر', href: '/parent-link-requests', icon: 'inbox', roles: ['admin', 'manager'], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'التواصل', href: '/communication', icon: 'whatsapp', roles: ['admin', 'manager'], permission: 'can_communicate', orgTypes: ['club', 'academy'], enabled: true },
      { name: 'حجز الملاعب', href: '/venue-booking', icon: 'field', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
    ],
  },
  {
    group: 'المنشأة والموارد البشرية',
    key: 'hr',
    items: [
      { name: 'الموظفون والإداريون', href: '/staff-admin', icon: 'briefcase', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'تقييم الأداء', href: '/performance-review', icon: 'chart', roles: ['admin', 'manager'], permission: null, orgTypes: ['club', 'academy'], enabled: true },
    ],
  },
  {
    group: 'المدربون والعمل الفني',
    key: 'coaching',
    items: [
      { name: 'الطاقم التدريبي', href: '/coaching-staff', icon: 'whistle', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'استقطاب المدربين', href: '/coach-recruitment', icon: 'search', roles: ['admin', 'manager'], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'التدريب المشترك', href: '/shared-coaching', icon: 'field', roles: ['admin', 'manager'], permission: null, orgTypes: ['club', 'academy'], enabled: true },
    ],
  },
  {
    group: 'الإدارة والحوكمة',
    key: 'governance',
    items: [
      { name: 'مجلس الإدارة', href: '/board-of-directors', icon: 'building', roles: [], permission: null, orgTypes: ['club'], enabled: true },
      { name: 'الحوكمة والإنجازات', href: '/governance-strategy-pro', icon: 'flag', roles: [], permission: null, orgTypes: ['club'], enabled: true },
    ],
  },
  {
    group: 'الإدارة المالية',
    key: 'finance',
    roles: FINANCE_ROLES,
    items: [
      { name: 'الإدارة المالية', href: '/finance', icon: 'banknotes', roles: FINANCE_ROLES, permission: 'view_finance', orgTypes: ['club', 'academy'], enabled: true },
    ],
  },
  {
    group: 'التقارير والتحليلات',
    key: 'analytics',
    items: [
      { name: 'مركز التقارير', href: '/reports', icon: 'chart', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
    ],
  },
  {
    group: 'النظام والدعم',
    key: 'system',
    items: [
      { name: 'سجل النشاط', href: '/activity-log', icon: 'clock', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'التطبيقات والتكاملات', href: '/integrations', icon: 'grid', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'الإعدادات', href: '/settings', icon: 'cog', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'المساعدة', href: '/help', icon: 'info', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
      { name: 'الدعم', href: '/support', icon: 'inbox', roles: [], permission: null, orgTypes: ['club', 'academy'], enabled: true },
    ],
  },
];

// عناوين كل Routes المنشأة (بما فيها غير الظاهرة في القائمة)
export const ROUTE_TITLES = {
  '/dashboard': 'لوحة التحكم',
  '/activity-log': 'سجل النشاط',
  '/players': 'اللاعبون',
  '/venue-booking': 'حجز الملاعب',
  '/teams': 'الفرق والفئات',
  '/matches': 'المباريات',
  '/tournaments': 'البطولات',
  '/reports': 'مركز التقارير والتحليلات',
  '/staff-admin': 'الموظفون والإداريون',
  '/coaching-staff': 'الطاقم التدريبي',
  '/coach-recruitment': 'استقطاب المدربين',
  '/medical-staff': 'الطاقم الطبي',
  '/security-staff': 'الأمن والحراسة',
  '/general-services': 'الخدمات العامة',
  '/attendance': 'الحضور والانصراف',
  '/parent-link-requests': 'بوابة ولي الأمر',
  '/communication': 'التواصل',
  '/programs': 'برامج الأكاديمية',
  '/performance-review': 'تقييم الأداء',
  '/board-of-directors': 'مجلس الإدارة',
  '/governance-strategy-pro': 'الحوكمة والإنجازات',
  '/accounts': 'الملخص المالي',
  '/finance': 'الإدارة المالية',
  '/expenses': 'المصروفات',
  '/revenues': 'الإيرادات',
  '/payroll': 'الرواتب',
  '/budget': 'الميزانية',
  '/invoices': 'الفواتير',
  '/quotes': 'عروض الأسعار',
  '/financial-reports': 'التقارير المالية',
  '/settings': 'الإعدادات',
  '/integrations': 'التطبيقات والتكاملات',
  '/help': 'المساعدة',
  '/support': 'الدعم',
  '/shared-coaching': 'التدريب المشترك',
};

const roleAllowed = (item, user) => {
  if (item.permission === 'can_communicate') {
    if (!user) return false;
    return user.is_super_admin || user.role === 'admin' || user.role === 'manager' || !!user.can_communicate;
  }
  if (!item.roles || item.roles.length === 0) return true;
  if (!user) return false;
  return user.is_super_admin || item.roles.includes(user.role);
};

// القائمة المرئية بعد تطبيق الأدوار وحالة التفعيل (الحماية الفعلية في الخادم)
export const getVisibleNavigation = (user) =>
  organizationNavigation
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => item.enabled && roleAllowed(item, user)),
    }))
    .filter((group) => group.items.length > 0 && roleAllowed(group, user));

export const getRouteTitle = (pathname) => {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  const base = Object.keys(ROUTE_TITLES).find((r) => pathname.startsWith(r + '/'));
  return base ? ROUTE_TITLES[base] : 'لوحة التحكم';
};
